import React, { Component } from "react";
import PropTypes from "prop-types";
import { Card, CardBody, CardTitle, Modal, Table } from "reactstrap";
import { Link } from "react-router-dom";
import { map } from "lodash";

class AttachedFiles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      subscribemodal: false,
    };
  }
  render() {
    return (
      <Card>
        <CardBody>
          <CardTitle className="mb-4">E-QA Certificates</CardTitle>
          <div className="table-responsive">
            <Table className="table table-nowrap align-middle table-hover mb-0">
              <tbody>
                {map(this.props.files, (file, i) => (
                  <tr key={"_file_" + i}>
                    <td style={{ width: "45px" }}>
                      <div className="avatar-sm">
                        <span className="avatar-title rounded-circle bg-primary bg-soft text-primary font-size-24">
                          <i className="bx bxs-file-doc" />
                        </span>
                      </div>
                    </td>
                    <td>
                      <h5 className="font-size-14 mb-1">
                        <Link to="#" className="text-dark">
                          {file.name}
                        </Link>
                      </h5>
                      <small>Size : {file.size}</small>
                    </td>
                    <td>
                      <div className="text-center">
                        <Link
                          to={file.link}
                          onClick={() =>
                            this.setState({ subscribemodal: true })
                          }
                          className="text-dark"
                        >
                          <i className="bx bx-download h3 m-0" />
                        </Link>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </CardBody>
        <Modal
          isOpen={this.state.subscribemodal}
          role="dialog"
          autoFocus={true}
          data-toggle="modal"
          centered
          toggle={this.togglesubscribemodal}
        >
          <div className="modal-content">
            <div className="modal-header border-bottom-0">
              <button
                type="button"
                className="btn-close"
                onClick={() => this.setState({ subscribemodal: false })}
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="text-center mb-4">
                <div className="avatar-md mx-auto mb-4">
                  <div className="avatar-title bg-light  rounded-circle text-primary h1">
                    <i className="dripicons-box"></i>
                  </div>
                </div>

                <div className="row justify-content-center">
                  <div className="col-xl-10">
                    <h4 className="text-primary">Comming Soon !</h4>
                    <p className="text-muted font-size-14 mb-4">
                      Download Option will be when the application will go
                      live
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </Card>
    );
  }
}

AttachedFiles.propTypes = {
  files: PropTypes.array,
};

export default AttachedFiles;
